import partner from "~/utils/partner";

const checkApiByParnerId = () => {
  switch (partner) {
    case "umc":
      return "https://medpro-api-v3-testing.medpro.com.vn";

    default:
      return "https://medpro-api-v3-testing.medpro.com.vn";
  }
};

const checkApiLogin = () => {
  switch (partner) {
    // case "nhidonghcm":
    // case "medpro":
    //   return `https://id-v121.medpro.com.vn/check-phone`;

    default:
      // return "http://localhost:9999/check-phone";
      return `https://id-testing.medpro.com.vn/check-phone`;
  }
};

// Api backend
export const RESTFULL_API_URL = checkApiByParnerId();

// Api hình ảnh và nội dung
export const STATIC_CONTENT_API_URL = "https://resource-testing.medpro.com.vn";

// Link login tới medproId

export const MEDPRO_LOGIN = checkApiLogin();

// Thời gian sống 12*60*60; // 12 tiếng
export const COOKIE_EXPIRES = 43200;

// wechat
export const SOCKET_CHAT = "wss://alpha-api.medpro.com.vn/cable";

// link thanh toán paymenthub
export const PAYMENT_HUB_URL =
  "https://payment-gateway-qrcode-testing.medpro.com.vn";

export const LINK_API_COVID19 = "https://khaibaoyte-testing.medpro.com.vn";
